import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import React from 'react'

export const CreditCardFormContainer: React.VFC<{
    children: React.ReactNode
}> = (props) => {
    const { children } = props
    const stripePromise = loadStripe(
        process.env.REACT_APP_STRIPE_PUBLIC_KEY as string
    )

    return <Elements stripe={stripePromise}>{children}</Elements>
}
